import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface InsertRoleActionsFromRefRequest {
  resourceRoleId: number;
  targetRoleId: number;
  resourceIds: string;
}

export type InsertRoleActionsFromRefResponse = {
  isSuccess: boolean;
  message: string;
  data: any;
};

async function insertRoleActionsFromRef(
  data: InsertRoleActionsFromRefRequest
): Promise<InsertRoleActionsFromRefResponse> {
  try {
    return (await axiosInstance.post("/RoleAction/InsertRoleActionsFromRef", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useInsertRoleActionsFromRef() {
  return useMutation<InsertRoleActionsFromRefResponse, Error, InsertRoleActionsFromRefRequest>(
    (variables) => insertRoleActionsFromRef(variables)
  );
}